import { useMemo } from 'react';
import ResponsiveTable from '../../../../../shared/components/ResponsiveTable';
import {
  HeaderPropSortCallback,
  SortedColumn,
} from '../../../../../shared/components/ResponsiveTable/models';
import { AdministratorUserApiModel, AdminActions } from '../models';
import NameCell from './TableCells/NameCell';
import RoleCell from './TableCells/RoleCell';
import ActionsCell from './TableCells/ActionsCell';
import RegisteredCell from './TableCells/RegisteredCell';
import styles from './adminsList.module.scss';
import InvitedByCell from './TableCells/InvitedByCell';
import LastLoggedIn from './TableCells/LastLoggedIn';

interface AdminsListProps {
  list: AdministratorUserApiModel[];
  isLoading: boolean;
  handleSort: HeaderPropSortCallback;
  actions: AdminActions;
  personId: number;
}

const getColumns = (
  hasItems: boolean,
  actions: AdminActions,
  personId: number,
): SortedColumn[] => [
  {
    name: 'name',
    title: 'Name',
    cell: (cntx) => <NameCell row={cntx.row} />,
    width: 30,
    sortingEnabled: hasItems,
  },
  {
    name: 'role',
    title: 'Role',
    cell: (cntx) => <RoleCell row={cntx.row} />,
    width: 15,
    sortingEnabled: hasItems,
  },
  {
    name: 'dateRegistered',
    title: 'Registration',
    cell: (cntx) => <RegisteredCell row={cntx.row} />,
    width: 15,
    sortingEnabled: hasItems,
  },
  {
    name: 'lastLoggedIn',
    title: 'Last Accessed',
    cell: (cntx) => <LastLoggedIn row={cntx.row} />,
    width: 15,
    sortingEnabled: hasItems,
  },
  {
    name: 'invitedByPersonName',
    title: 'Invited By',
    cell: (cntx) => <InvitedByCell row={cntx.row} />,
    width: 15,
    sortingEnabled: hasItems,
  },
  {
    name: 'actions',
    title: '',
    cell: (cntx) => (
      <ActionsCell row={cntx.row} actions={actions} personId={personId} />
    ),
    width: 1,
  },
];

export default function AdminsList({
  list = [],
  isLoading,
  handleSort,
  actions,
  personId = 0,
}: AdminsListProps) {
  const columns = useMemo(
    () => getColumns(list.length > 0, actions, personId),
    [personId, actions.removableAdmin],
  );
  return (
    <div className={`${styles.adminsTableContainer} overflow-auto`}>
      {!isLoading && (
        <ResponsiveTable
          data={list}
          onSort={handleSort}
          columns={columns}
          className={`overflow-auto admin-list-data ${styles.tableAdmins}`}
        />
      )}
      {isLoading && <p className="py-2">Loading...</p>}
    </div>
  );
}
